import {
  CopyFailedNotification,
  CopySuccessfulNotification,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import type { GlobalActions } from '@/store'

type Action = ReturnType<typeof GlobalActions.copy>

export function* clipboardCopy({ payload: { value } }: Action) {
  if (!navigator.clipboard) {
    // todo: remove old browser fallback, define supported browsers
    yield call(document.execCommand, 'copy')

    yield put(CopySuccessfulNotification)

    return
  }

  try {
    yield call([navigator.clipboard, 'writeText'], value)
    yield put(CopySuccessfulNotification)
  } catch (err) {
    console.error(err)
    yield put(CopyFailedNotification)
  }
}
